import React from "react";

import Grid from "@mui/material/Grid";
import { NoDataOverlay } from "@src/features/analytics/baseDashboard/charts/NoDataOverlay";

interface NoGraphDataProps {
  title?: string;
  body?: string;
}
export const NoGraphData = ({ title, body }: NoGraphDataProps) => {
  return (
    <Grid
      container
      direction={"column"}
      alignItems={"center"}
      sx={{ marginTop: "60px" }}
      justifyContent={"center"}
      rowSpacing={2}
      height={257}
    >
      <NoDataOverlay
        message1={title ?? "No Data Yet!"}
        message2={
          body ??
          "Check back later, it may take up to two hours after experiment launch for data to appear."
        }
      />
    </Grid>
  );
};
